import { render, staticRenderFns } from "./ReactionEmailModal.vue?vue&type=template&id=496f00b7&scoped=true&"
import script from "./ReactionEmailModal.vue?vue&type=script&lang=js&"
export * from "./ReactionEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./ReactionEmailModal.vue?vue&type=style&index=0&id=496f00b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496f00b7",
  null
  
)

export default component.exports